import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#custom-file-thumbnail" }),
  /*#__PURE__*/_createTextVNode(" Custom file thumbnail ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, "scoped-slot"),
  /*#__PURE__*/_createTextVNode(" to change default thumbnail template. ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_6 = { class: "el-upload-list__item-actions" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "el-icon-zoom-in" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "el-icon-download" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "el-icon-delete" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_upload, {
        action: "#",
        "list-type": "picture-card",
        "auto-upload": false
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        file: _withCtx(({file}) => [
          _createVNode("div", null, [
            _createVNode("img", {
              class: "el-upload-list__item-thumbnail",
              src: file.url,
              alt: ""
            }, null, 8, ["src"]),
            _createVNode("span", _hoisted_6, [
              _createVNode("span", {
                class: "el-upload-list__item-preview",
                onClick: ($event: any) => (_ctx.handlePictureCardPreview(file))
              }, [
                _hoisted_7
              ], 8, ["onClick"]),
              (!_ctx.disabled)
                ? (_openBlock(), _createBlock("span", {
                    key: 0,
                    class: "el-upload-list__item-delete",
                    onClick: ($event: any) => (_ctx.handleDownload(file))
                  }, [
                    _hoisted_8
                  ], 8, ["onClick"]))
                : _createCommentVNode("", true),
              (!_ctx.disabled)
                ? (_openBlock(), _createBlock("span", {
                    key: 1,
                    class: "el-upload-list__item-delete",
                    onClick: ($event: any) => (_ctx.handleRemove(file))
                  }, [
                    _hoisted_9
                  ], 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.dialogVisible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = $event))
      }, {
        default: _withCtx(() => [
          _createVNode("img", {
            width: "100%",
            src: _ctx.dialogImageUrl,
            alt: ""
          }, null, 8, ["src"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code4), 1)
        ]),
        _: 1
      })
    ])
  ]))
}